import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatPaginator, MatTableDataSource } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/libraries/globals';
import { EmpresasService } from 'src/app/services/empresas/empresas.service';
import { Dialogs } from 'src/app/ui/dialogs/dialogs';
import { Wait } from 'src/app/ui/wait/Wait';
import { EmpresasCreateComponent } from '../create/create.component';
import { EmpresasIndexUploadLogoComponent } from './upload-logo/upload-logo.component';
import { EmpresasIndexVendedoresComponent } from './vendedores/vendedores.component';

@Component({
  selector: 'comp-empresas-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
export class EmpresasIndexComponent implements OnInit {

  @ViewChild(MatPaginator, { static: false})    paginator       : MatPaginator;
  @ViewChild('tableContainer', {static: false}) tableContainer  : ElementRef;

  private lstEmpresas : Array<any> = [];
  private objDialogs  : Dialogs = new Dialogs();
  private index       : number;

  // SEARCH
  private txtSearch = new FormControl();

  // COLUMNS
  columns: string[] = ['index', 'opciones', 'name', 'razonSocial', 'rfc', 'telefono', 'celular', 'email', 'ciudad', 'estado', 'codigoPostal', 'createdAspNetUser', 'createdFecha', 'updatedAspNetUser', 'updatedFecha'];

  // SEARCH FILTERS
  searchFilters : Array<any> = [{field : 'Name'}, 
                                {field : 'RazonSocial'}, 
                                {field : 'RFC'},
                                {field : 'Telefono'},
                                {field : 'Celular'},
                                {field : 'Email'},
                                {field : 'Direccion'},
                                {field : 'Ciudad'},
                                {field : 'CodigoPostal'},
                                {field : 'TerminosCondiciones'},
                                {field : 'PiePaginga1'},
                                {field : 'PiePaginga2'}];
  
  dataSource : MatTableDataSource<any>;

  constructor(private objEmpresasService : EmpresasService,
              private dialog: MatDialog,
              private toastr: ToastrService) { }

  ngOnInit() {
    this.dataSource = new MatTableDataSource<any>();
  }

  ngAfterViewInit() {
    this.build();
  }

  // EVENTOS
  btnNuevo_clickEvent() {
    const dialogRef = this.dialog.open(EmpresasCreateComponent, {
      width     : '99%',
      height    : '99%',
      maxWidth  : '800px',
      maxHeight : '450px'
    });

    dialogRef.componentInstance.onChange.subscribe(() => {
      this.build();
    });
  }

  btnVendedores_clickEvent(element : any) {
    const dialogRef = this.dialog.open(EmpresasIndexVendedoresComponent, {
      width     : '99%',
      height    : '99%'
    });

    dialogRef.componentInstance.objData = element;
  }

  btnUploadLogo_clickEvent(element : any) {
    const dialogRef = this.dialog.open(EmpresasIndexUploadLogoComponent, {
      width     : '99%',
      height    : '99%',
      maxWidth  : '600px',
      maxHeight : '520px'
    });

    dialogRef.componentInstance.objData = element;

    dialogRef.componentInstance.onChange.subscribe(() => {
      this.build();
    });
  }

  btnEdit_clickEvent(element : any) {
    
    const dialogRef = this.dialog.open(EmpresasCreateComponent, {
      width     : '99%',
      height    : '99%',
      maxWidth  : '800px',
      maxHeight : '450px'
    });

    dialogRef.componentInstance.objData = element;
    dialogRef.componentInstance.isEdit  = true;

    dialogRef.componentInstance.onChange.subscribe(() => {
      this.build();
    });

  }

  btnDelete_clickEvent(element : any) {
    
    this.objDialogs.Confirm("Eliminar", "¿Eliminar empresa "+ element.name +"?", "Eliminar", "Cancelar", ()=> {
      this.delete(element.idEmpresa);
    });

  }

  // METODOS
  private build() : void {

    let varArgs : any = {
      search              : Globals.validValue(this.txtSearch.value) ? this.txtSearch.value : "",
      searchFilters       : this.searchFilters,
      filters             : [],
      dateFrom            : "",
      dateTo              : "",
      dateOptions         : [{field : "CreatedFecha"}],
      columns             : [],
      persistenceColumns  : [],
      length              : !Globals.validValue(this.paginator.pageSize) ? 15 : this.paginator.pageSize,
      page                : this.paginator.pageIndex + 1
    };

    Wait.show(this.tableContainer, "Cargando datos...");

    this.objEmpresasService.dataSource(varArgs)
    .subscribe( objResponse => {

      if(objResponse.session) {

        if(objResponse.action) {

          this.lstEmpresas          = objResponse.result.rows;

          this.dataSource           = new MatTableDataSource(this.lstEmpresas);
          this.paginator.pageIndex  = objResponse.result.page - 1;
          this.paginator.pageSize   = objResponse.result.length;
          this.paginator.length     = objResponse.result.count;
          this.index                = this.paginator.pageIndex * this.paginator.pageSize + 1;

        } else {
          this.toastr.error(objResponse.message, objResponse.title, { timeOut: 2000 });
        }

      } else {
        this.toastr.error(objResponse.message, objResponse.title, { timeOut: 2000 });
      }
      
      Wait.hide(this.tableContainer);
      
    }, error => {
      Wait.hide(this.tableContainer);

      if( error.status == 401) {
        this.toastr.error("La sesión ha finalizado.", "Error de sesión", { timeOut: 2000 });
      } else {
        this.toastr.error("Póngase en contacto con el administrador.", "Error de conexión al servidor");
      }

    });
    
  }

  private borrarFiltros() : void {
    this.txtSearch.setValue("");
    this.build();
  }

  private delete(idEmpresa : any) : void {
    
    Wait.show(this.tableContainer, "Eliminando...")

    let objEmpresaDelete : any =
    {
      idEmpresa : idEmpresa
    };

    this.objEmpresasService.delete(objEmpresaDelete)
    .subscribe( objResponse => {
    
      if(objResponse.session) {

        if(objResponse.action) {
          
          this.build();
          this.objDialogs.Success(objResponse.title, objResponse.message);
          
        } else {
          this.toastr.error(objResponse.message, objResponse.title, { timeOut: 2000 });
        }
      } else {
        this.toastr.error(objResponse.message, objResponse.title, { timeOut: 2000 });
      }

      Wait.hide(this.tableContainer);

    }, error => {

      Wait.hide(this.tableContainer);

      if( error.status == 401) {
        this.toastr.error("La sesión ha finalizado.", "Error de sesión", { timeOut: 2000 });
      } else {
        this.toastr.error("Póngase en contacto con el administrador.", "Error de conexión al servidor");
      }

    });
  }

}
